export enum RideType {
    Passenger = 0,
    Freight = 1,
}